/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Postal address.   (bipro-allgemein::Adresse)
 */
export interface Address {
  street?: string;
  houseNumber?: string;
  postCode?: string;
  city?: string;
  /**
   * Country code with two characters according to ISO-3166-1 Alpha 2.
   */
  countryCode?: string;
}
